const WIDGET_ORDER_STORAGE_KEY = 'dabih_widget_order';

/**
 * Lagrer brukerens egendefinerte rekkefølge på widgets på oversikten.
 * Persistert i localStorage per organisasjon (per nettleser).
 * Tom liste betyr standard rekkefølge.
 */
export class WidgetOrderService {
  private static getStorageKey(organizationId: number): string {
    return `${WIDGET_ORDER_STORAGE_KEY}_${organizationId}`;
  }

  static getWidgetOrder(organizationId: number): string[] {
    try {
      const data = localStorage.getItem(this.getStorageKey(organizationId));
      if (!data) {
        return [];
      }
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Error reading widget order:', error);
      return [];
    }
  }

  static saveWidgetOrder(organizationId: number, widgetNames: string[]): void {
    try {
      localStorage.setItem(this.getStorageKey(organizationId), JSON.stringify(widgetNames));
    } catch (error) {
      console.error('Error saving widget order:', error);
    }
  }

  static clearWidgetOrder(organizationId: number): void {
    try {
      localStorage.removeItem(this.getStorageKey(organizationId));
    } catch (error) {
      console.error('Error clearing widget order:', error);
    }
  }
}
